import styled from "styled-components";
import {GameJackpotBarContributionLabelDefaultBox} from "./game-jackpot-bar-contribution-label.default.box";
import {baseColors} from "../../../../../../themes/definitions/casino888/base-colors";

export const GameJackpotBarContributionLabelCasino888CipBox = styled(GameJackpotBarContributionLabelDefaultBox)<{isOptInStatus?: boolean}>`
    color: ${({isOptInStatus}) => isOptInStatus ? baseColors.base01 : baseColors.base04};
`;